function togglePasswordVisibility(btn: HTMLButtonElement){
    const input = btn.parentElement!.getElementsByTagName("input")[0];
    if (input.type === "password"){
        // Reveal password and focus on input
        input.type = "text";
        input.focus();
        // Update icon and ARIA state
        btn.classList.add('icon-peloton-green');
        btn.setAttribute('aria-pressed', 'true');
    } else {
        // Hide password and focus on input
        input.type = "password";
        input.focus();
        // Update icon and ARIA state
        btn.classList.remove('icon-peloton-green');
        btn.setAttribute('aria-pressed', 'false');
    }
}

document
    .querySelectorAll<HTMLButtonElement>("[data-toggle-password-reveal]")
    .forEach((btn: HTMLButtonElement) => btn
        .addEventListener("click", (event: MouseEvent) => event.currentTarget instanceof HTMLButtonElement
            ? togglePasswordVisibility(event.currentTarget)
            : {}))
